export const URISpaceReplace = (str: string) => {
  return typeof str === 'string' ? str.replace(/\s/g, '+') : '';
};
